import { CircularProgress, Grid } from '@mui/material'
import { AttachMoney } from '@mui/icons-material'
import { FormikHelpers } from 'formik'
import { inject } from 'mobx-react'
import { runInAction } from 'mobx'
import * as React from 'react'
import AddressField from '../common/AddressField/AddressField'
import ESDialog from '../common/ESDialog'
import FullWidthField from '../common/FullWidthField'
import { ILocationBilling } from '../Definitions'
import { IStores } from '../Stores'
import * as Yup from 'yup'
import {
  ILocationBillingFormValues,
  createILocationBillingFormValues,
} from './LocationBillingFormValues'
import { AddressDTO } from 'src/viewModels/AddressDTO'
import { UpdateAllLocationBillingAddresses } from 'src/services/ProviderService'

const LocationBillingSchema = Yup.object().shape({
  address: Yup.object().shape({
    city: Yup.string().required('City is required'),
    line1: Yup.string().required('Street Address is required'),
    line2: Yup.string(),
    name: Yup.string().required('Billing Name is required'),
    state: Yup.string().required('State is required'),
    zip: Yup.string().required('ZIP code is required'),
  }),
})

interface IUpdateAllBillingAddressModalProps {
  close?: () => void
  isLoading?: boolean
  isOpen?: boolean
  locationBilling?: ILocationBilling
  locationBillingStore?: any
  providerId: string
}

@inject((stores: IStores) => ({
  close: stores.locationBillings.closeDialog,
  isLoading: stores.locationBillings.isLoading,
  isOpen: stores.locationBillings.isModalOpen,
  locationBilling: stores.locationBillings.selectedLocationBilling,
  locationBillingStore: stores.locationBillings,
}))
export default class UpdateAllBillingAddressModal extends React.Component<IUpdateAllBillingAddressModalProps> {
  public save = async (
    values: ILocationBillingFormValues,
    formikBag: FormikHelpers<ILocationBillingFormValues>
  ) => {
    if (this.props.locationBilling!.isNew) {
      let address = new AddressDTO()
      address.line1 = values.address?.line1
      address.line2 = values.address?.line2
      address.city = values.address?.city
      address.state = values.address?.state
      address.zip = values.address?.zip
      address.phoneNumber = values.address?.phoneNumber
      address.name = values.address?.name

      runInAction(() => {
        this.props.locationBillingStore!.isLoading = true
      })

      UpdateAllLocationBillingAddresses(this.props.providerId, address).finally(() => {
        formikBag.setSubmitting(false)
        runInAction(() => {
          this.props.locationBillingStore!.isLoading = false
        })
        this.props.close!()
      })
    }
  }

  public render() {
    const { close, isLoading, isOpen } = this.props
    const initialValues = this.props.locationBilling
      ? createILocationBillingFormValues('', this.props.locationBilling)
      : undefined

    return (
      <>
        {this.props.locationBillingStore!.isLoading && (
          <div
            style={{
              position: 'fixed',
              display: 'flex',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              cursor: 'pointer',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1400,
            }}
          >
            <CircularProgress size={100} />
          </div>
        )}
        <ESDialog
          close={close!}
          isLoading={isLoading}
          open={isOpen!}
          save={this.save}
          title="Update Billing Addresses For All Locations in Group"
          validationSchema={LocationBillingSchema}
          titleIcon={<AttachMoney />}
          initialValues={initialValues}
        >
          {({}) => (
            <Grid container spacing={3} style={{ marginTop: 8 }}>
              <Grid item xs={12}>
                <FullWidthField
                  autoFocus
                  name="address.name"
                  label="Billing Name"
                  required
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <AddressField
                  outlined
                  name="address"
                  label="Address"
                  showPhone={true}
                  required={true}
                />
              </Grid>
            </Grid>
          )}
        </ESDialog>
      </>
    )
  }
}
